import React from "react";
import { Outlet } from "react-router-dom";

import { Modals } from "Components/Modals";
import { Warning } from "Components/Warning/Warning";
import { NavigationBar } from "Components/NavigationBar/NavigationBar";
import { LocalStorageCache } from "Components/LocalStorageCache";
import { useResetEntitiesOnLogOut } from "Utils/hooks";

import { AuthorizedAppLoader } from "./AuthorizedApp.loader";
import { AuthorizedAppGuard } from "./AuthorizedApp.guard";
import { AppStyled } from "./styles";
import { WebsocketLoaderController } from "Pages/AuthorizedApp/WebsocketLoaderController";

// Token refresh is owned by the shared `AuthProvider` (DEV-6053); nothing here schedules it.
export const AuthorizedApp = () => {
  useResetEntitiesOnLogOut();

  return (
    <>
      <LocalStorageCache />
      <AppStyled>
        <NavigationBar />
        <Modals />
        <Warning />
        <AuthorizedAppLoader>
          <AuthorizedAppGuard>
            <WebsocketLoaderController>
              <Outlet />
            </WebsocketLoaderController>
          </AuthorizedAppGuard>
        </AuthorizedAppLoader>
      </AppStyled>
    </>
  );
};
